import React, { useState, useEffect } from "react"
import ReactDOM from 'react-dom';
import './index.css';
import Rotate360View from "./Rotate360View";

const AppView = ({}) => {
  /**
   * ペンモードか
   * @type {bool}
   */
  const [isPen, setPen] = useState(false);

  /**
   * ズームモードか
   * @type {bool}
   */
  const [isZoom, setZoom] = useState(false);

  /**
   * 消しゴムモードか
   * @type {bool}
   */
  const [isEraser, setEraser] = useState(false);

  /**
   * テロップ表示しているか
   * @type {bool}
   */
  const [isTelop, setTelop] = useState(window.config.telopInfo.display);

  /**
   * FFL
   * @type {Window}
   */
  const FFL = window.parent;

  /**
   * 拡大ボタンOffイメージファイル
   * @type {string}
   */
  const zoomIconOffImg = "./apps/common/zoomIcon_off.png";

  /**
   * 拡大ボタンOnイメージファイル
   * @type {string}
   */
   const zoomIconOnImg = "./apps/common/zoomIcon_on.png";

  /**
   * 名前ボタンOffイメージファイル
   * @type {string}
   */
  const nameIconOffImg = "./apps/common/nameIcon_off.png";

  /**
   * 名前ボタンOnイメージファイル
   * @type {string}
   */
   const nameIconOnImg = "./apps/common/nameIcon_on.png";

  /**
   * イベント登録
   */
   useEffect(() => {
    // ツールバーイベントリスナー登録/解除
    window.addEventListener("message", setEvent);
    return () => {
      window.removeEventListener("message", setEvent);
    };
  }, [isPen, isZoom])

  /**
   * ズーム切り替え
   */
  useEffect(() => {
    let btnZoomImg = document.getElementById('btnZoomImg');
    if (isZoom) {
      btnZoomImg.src = zoomIconOnImg;
    } else {
      btnZoomImg.src = zoomIconOffImg;
    }
  }, [isZoom])

  /**
   * テロップ切り替え
   */
  useEffect(() => {
    let telop = document.getElementById('telop');
    let btnTelopImg = document.getElementById('btnTelopImg');
    if (isTelop) {
      // 表示
      telop.style.display = (isPen || isEraser) ? "none" : "block";
      btnTelopImg.src = nameIconOnImg;
    } else {
      // 非表示
      telop.style.display = "none";
      btnTelopImg.src = nameIconOffImg;
    }
  }, [isTelop])
  
  /**
   * FFLからのイベント処理
   * @param {any} _evt イベント
   */
  function setEvent(_evt) {
    const eventData = (_evt.data + "").split("[,]");
    // console.log(eventData);

    // サイドバー初期化時にstateを初期化
    // if (eventData[0] === "FFLCOM_GET_SIDEBAR_CONFIG") {
    //   setCallSidebarConfig(true);
    // }
    if (eventData[0] === "FFLCOM_SET_MODE_FINGER") {
      // タッチ：ON、ペン/ズーム/消しゴム：OFF
      setPen(false);
      setEraser(false);
      // FFL.ws_zoom.setState(false);
      FFL.ws_eraser.setState(false);
      // 次へ/前へボタン再設定(リサイズ時にボタン操作無効が剥がされないように対応)
      // FFL.ws_prev.updateButton();
      // FFL.ws_next.updateButton();
    }
    else if (eventData[0] === "FFLCOM_CHANGE_TOOL") {
      if (eventData[1] === "FFLCOM_TOOL_PEN" || eventData[1] === "FFLCOM_TOOL_MARKER") {
        // ペン：ON、ズーム/消しゴム：OFF
        setPen(true);
        setEraser(false);
        setZoom(false);
      }
    }
    else if (eventData[0] === "FFLCOM_ORIGINAL") {
      // 各ボタン毎の処理
      switch (eventData[1]) {
        case "ws_finger":
          // タッチON、ズーム/消しゴムOFF
          setEraser(false);
          setZoom(false);
          FFL.ws_finger.setState(true);
          FFL.ws_eraser.setState(false);
          break;
        case "ws_eraser":
          // 消しゴムON、タッチ/ズームOFF
          setEraser(true);
          setZoom(false);
          FFL.ws_finger.setState(false);
          FFL.ws_eraser.setState(true);
          break;
        default:
          break;
      }
    }
  };

  /**
   * ズームモードの切り替え
   */
  const changeZoomMode = () => {
    if (isPen || isEraser) { return; }

    if (isZoom === true) {
      // 無効
      setZoom(false);
    } else {
      // 有効
      setZoom(true);
    }
  }
    
  /**
   * テロップの表示・非表示の切り替え
   */
  const changeTelop = () => {
    if (isPen || isEraser) { return; }

    if (isTelop) {
      setTelop(false);
    } else {
      setTelop(true);
    }
  }

  return (
    <div>
      <button id='btnZoom' onClick={() => { changeZoomMode(); }} style={{width: 100, height: 60, borderRadius: 2, fontSize: 20, border: "none", background: "transparent"}}>
        <img id='btnZoomImg' src={zoomIconOffImg} className='icon_img' style={{width: 100, height: 60, position: "absolute", marginLeft: -50, marginTop: -30}}></img>
      </button>
      <button id='btnTelop' onClick={() => { changeTelop(); }} style={{width: 100, height: 60, borderRadius: 2, fontSize: 20, border: "none", background: "transparent"}}>
        <img id='btnTelopImg' src={nameIconOffImg} className='icon_img' style={{width: 100, height: 60, position: "absolute", marginLeft: -50, marginTop: -30}}></img>
      </button>
      <Rotate360View isTelop={isTelop} isZoom={isZoom} isPen={isPen} isEraser={isEraser}/>
    </div>
  )
}

ReactDOM.render(
  <React.StrictMode>
    <div>
      <AppView/>
    </div>
  </React.StrictMode>,
  document.getElementById('root')
);